import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const MOBILE_PAY: PaymentMethod = {
    id: PAYMENT_METHOD_ID.MobilePay,
    name: 'mobilepay',
    displayName: 'MobilePay'
};
